import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CaseStateType, CustomError } from 'types';
import { getCaseDetails } from 'services/product-service/getCaseDetails';
import { CaseServiceDetailsResponse } from 'pco-product-service-internal-consumer';
import { closeModal, openModal } from './modalReducer';

export const initialCaseState: CaseStateType = {
  isLoading: false,
  selectedToDistribute: [],
};

export const getCaseDetailsThunk = createAsyncThunk('CASE/getCaseDetails', async (caseId: string, thunkAPI) => {
  try {
    return await getCaseDetails(caseId);
  } catch (error: unknown) {
    thunkAPI.dispatch(
      openModal({
        modalType: 'JBErrorModalWrapper',
        modalProps: {
          httpError: error,
          okHandler: () => {
            thunkAPI.dispatch(closeModal());
          },
          technicalInfo: {
            title: 'Error when retrieving Case details',
            userErrorMessage: `An error occurred when retrieving Case details. Please try again later.`,
          },
        },
      }),
    );
  }
});

const caseSlice = createSlice({
  name: 'CASE',
  initialState: initialCaseState,
  reducers: {
    setCase: (state, action: PayloadAction<CaseServiceDetailsResponse>) => {
      return { ...state, case: action.payload };
    },
    setSelectedDocuments: (state, action: PayloadAction<string[]>) => {
      return { ...state, selectedToDistribute: action.payload };
    },
    setCaseError: (state, action: PayloadAction<CustomError | undefined>) => {
      return { ...state, error: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCaseDetailsThunk.pending, (state) => {
      return { ...state, isLoading: true };
    });
    builder.addCase(getCaseDetailsThunk.rejected, (state, action) => {
      return { ...state, error: action.payload as CustomError };
    });
    builder.addCase(getCaseDetailsThunk.fulfilled, (state, action) => {
      return { ...state, isLoading: false, case: action.payload };
    });
  },
});

export const { setCase, setCaseError, setSelectedDocuments } = caseSlice.actions;
export default caseSlice.reducer;
